import React, { useState } from 'react';
import ScoreGauge from './ScoreGauge';
import ScoreBar from './ScoreBar';

const DOC_NAMES = {
  coverLetter: 'cover letter',
  cv: 'CV',
  resume: 'resume',
  linkedin: 'LinkedIn profile',
  bio: 'bio',
  portfolio: 'portfolio',
};

function verdict(score, docType) {
  const name = DOC_NAMES[docType] || 'document';
  if (score >= 95) return `This ${name} is highly competitive and ready to submit.`;
  if (score >= 90) return `This ${name} is strong — a few small improvements could push it higher.`;
  if (score >= 80) return `This ${name} is solid. Review the suggestions below to strengthen it.`;
  if (score >= 70) return `This ${name} needs work in several areas before submitting.`;
  return `This ${name} requires significant revision. Review the sections below to see where it's falling short.`;
}

const ScoresTab = ({ result }) => {
  const [atsOpen, setAtsOpen] = useState(true);
  const [humanOpen, setHumanOpen] = useState(true);

  const ats = Number(result.atsOverall) || 0;
  const human = Number(result.humanOverall) || 0;
  const overall = ats && human ? Math.round((ats + human) / 2) : ats || human;

  const atsCategories = result.atsCategories || [];
  const humanCategories = result.humanCategories || [];

  return (
    <div className="scores-tab">
      <div className="scores-hero">
        <ScoreGauge score={overall} size={120} strokeWidth={8} />
        <p className="scores-verdict">{verdict(overall, result.docType)}</p>
      </div>

      <div className="scores-sections">
        {/* ATS Section */}
        {ats > 0 && (
          <div className="scores-section">
            <button
              className="scores-section-header"
              onClick={() => setAtsOpen((o) => !o)}
            >
              <span className="scores-section-label">ATS Score</span>
              <span className="scores-section-overall">{ats}%</span>
              <span className="scores-chevron">{atsOpen ? '▲' : '▼'}</span>
            </button>
            {atsOpen && atsCategories.length > 0 && (
              <div className="scores-section-body">
                {atsCategories.map((cat, i) => (
                  <ScoreBar
                    key={i}
                    label={cat.category}
                    value={cat.achieved_percent}
                  />
                ))}
              </div>
            )}
          </div>
        )}

        {/* Human Section */}
        {human > 0 && (
          <div className="scores-section">
            <button
              className="scores-section-header"
              onClick={() => setHumanOpen((o) => !o)}
            >
              <span className="scores-section-label">Human Score</span>
              <span className="scores-section-overall">{human}%</span>
              <span className="scores-chevron">{humanOpen ? '▲' : '▼'}</span>
            </button>
            {humanOpen && humanCategories.length > 0 && (
              <div className="scores-section-body">
                {humanCategories.map((cat, i) => (
                  <ScoreBar
                    key={i}
                    label={cat.category}
                    value={cat.achieved_percent}
                  />
                ))}
              </div>
            )}
          </div>
        )}

        {ats === 0 && human === 0 && (
          <p style={{ fontSize: 12, color: 'var(--text-tertiary)', textAlign: 'center', padding: '16px 0' }}>
            Score data unavailable for this document.
          </p>
        )}
      </div>
    </div>
  );
};

export default ScoresTab;
